import styled from "styled-components";

export const Container = styled.div`
  max-height: 450px;
  min-height: 300px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-height: unset;
    min-height: unset;
  }
`;
